var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 29,
  height: 30,
  viewBox: "0 0 29 30",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.38 15.2C28.38 22.932 22.112 29.2 14.38 29.2C6.64802 29.2 0.380005 22.932 0.380005 15.2C0.39604 11.0223 2.26394 7.06671 5.48 4.40005L8.28 7.30005C5.81534 9.17796 4.37208 12.1015 4.38 15.2C4.38 20.7229 8.85716 25.2 14.38 25.2C19.9029 25.2 24.38 20.7229 24.38 15.2C24.3879 12.1015 22.9447 9.17796 20.48 7.30005L23.28 4.40005C26.4961 7.06671 28.364 11.0223 28.38 15.2ZM16.38 0.800049H12.38V16.8H16.38V0.800049Z"
})));
export default SvgLogout;